import {Component, Injector, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AppComponent} from '../../../app.component';
import {IAssinatura} from '../../../core/interfaces/assinatura.interface';
import {IDadosCliente} from '../../../core/interfaces/dados_cliente.interface';
import {IDadosProduto} from '../../../core/interfaces/dados_produto.interface';
import {CategoriaPlanoService} from '../../../core/services/categoria_plano.service';
import {RdService} from '../../../core/services/rd.service';
import {CupomService} from '../../../core/services/cupom.service';
import {AssociadoService} from '../../../core/services/associado.service';
import {PropostaService} from '../../../core/services/proposta.service';
import {CepService} from '../../../core/services/cep.service';
import {Meta, Title} from '@angular/platform-browser';
import {ProdutoService} from '../../../core/services/produto.service';
import {AssinaturaService} from '../../../core/services/assinatura.service';
import {PropostaComponent} from '../proposta';
import {DeviceDetectorService} from 'ngx-device-detector';
import {TYPE_META} from '../../../core/constants/meta_title.constant';
import { ReCaptchaV3Service } from 'ngx-captcha';

@Component({
    selector: 'app-dados-pessoais',
    templateUrl: './dados-pessoais.component.html',
    styleUrls: ['./dados-pessoais.component.sass']
})
export class DadosPessoaisComponent extends PropostaComponent implements OnInit {
    public form: FormGroup;
    public propostaAndamento: any;
    public siteKey: string;
    public size: 'compact' | 'normal';
    public lang: string;
    public theme: 'light' | 'dark';
    public type: 'image' | 'audio';
    public badge: 'bottomright' | 'bottomleft' | 'inline';
    constructor(
        protected injector: Injector,
        public cupomService: CupomService,
        public propostaService: PropostaService,
        public associadoService: AssociadoService,
        public router: Router,
        public toast: ToastrService,
        private route: ActivatedRoute,
        public cepService: CepService,
        public rdService: RdService,
        formBuilder: FormBuilder,
        public categoriaPlanoService: CategoriaPlanoService,
        public appComponent: AppComponent,
        public titleService: Title,
        public meta: Meta,
        public produtoService: ProdutoService,
        public assinaturaService: AssinaturaService,
        public deviceService: DeviceDetectorService,
        private reCaptchaV3Service: ReCaptchaV3Service
        ) {
        super(injector);
        this.siteKey = '6LcWJW8eAAAAAN6e3qBV1_N8nApyPFWCDIJeSxgD';
        this.size = 'normal';
        this.lang = 'pt-br';
        this.theme = 'light';
        this.type = 'image';
        this.badge = 'inline';

        const proposta = this.getPropostaParaStorage();

        this.form = formBuilder.group({
            // celular: new FormControl(proposta ? proposta.celular : null, [Validators.required]),
            cpf: new FormControl(proposta ? proposta.cpf : null, [Validators.required]),
            // nome: new FormControl(proposta ? proposta.nome : null, [Validators.required]),
            dataNascimento: new FormControl(
                proposta && proposta.dataNascimento ?
                    this.formatarDataPtBr(proposta.dataNascimento) :
                    null,
                [Validators.required]
            ),
            // email: new FormControl(proposta ? proposta.email : null, [Validators.required, Validators.email]),
            // confirmaEmail: new FormControl(null, [Validators.required]),
            cep: new FormControl(proposta ? proposta.cep : null, [Validators.required]),
            Codigo_IBGE_c: new FormControl(proposta ? proposta.Codigo_IBGE_c : null, [Validators.required]),
            endereco: new FormControl(proposta ? proposta.endereco : null, [Validators.required]),
            numero: new FormControl(proposta ? proposta.numero : null, [Validators.required]),
            complemento: new FormControl(proposta ? proposta.complemento : null, []),
            bairro: new FormControl(proposta ? proposta.bairro : null, [Validators.required]),
            cidade: new FormControl(proposta ? proposta.cidade : null, [Validators.required]),
            uf: new FormControl(proposta ? proposta.estado : null, [Validators.required]),
            recaptcha: new FormControl('', [Validators.required])
        }, {
            validator: (group: FormGroup) => {
                // this.validaEmails(group);
                this.validaData(group);
            }
        });

        this.tratarDadoPropostaSessao();
    }

    getErrorMessage(field: string) {
        const input = this.form.get(field);
        return input.hasError('required') ? 'Campo obrigatório' :
            input.hasError('cpf') ? 'CPF inválido' :
                input.hasError('invalidDate') ? 'Insira uma data válida.' :
                    // input.hasError('notSame') ? 'E-mail não confere.' :
                    //     input.hasError('email') ? 'E-mail inválido.' :
                            '';
    }

    async ngOnInit() {
        this.setMetaTitle(TYPE_META.CARRINHO.DADOS_PESSOAIS);
        this.appComponent.showOverlay();
        this.form.markAllAsTouched();
        await this.inOnInit();
        this.appComponent.hideOverlay();
    }

    tratarDadoPropostaSessao() {
        this.propostaAndamento = this.getPropostaParaStorage();

        // if (this.propostaAndamento) {
        //     this.form.get('email').setValue(this.propostaAndamento.email);
        // }
    }

    // validaEmails(group: FormGroup) {
    //     const pass = group.get('email').value;
    //     const confirmPass = group.get('confirmaEmail').value;
    //
    //     if (pass !== confirmPass) {
    //         group.get('confirmaEmail').setErrors({ notSame: true });
    //     }
    // }

    validaData(group: FormGroup) {
        const dataNascimento = group.get('dataNascimento').value;

        if (dataNascimento == null) {
            return;
        }

        if (dataNascimento.length < 8) {
            group.get('dataNascimento').setErrors({ invalidDate: true });
            return;
        }

        if (this.formatarDataNascimento(group) == null) {
            group.get('dataNascimento').setErrors({ invalidDate: true });
        }
    }

    async validaExistCpf($event) {

        const cpf = this.form.get('cpf').value;
        if (cpf && cpf.length === 11) {
            this.appComponent.showOverlay();
            await this.clientValidate(cpf, 'CPF');
            this.appComponent.hideOverlay();
        }
    }

    limparCpf() {
        this.form.get('cpf').setValue('');
        this.UserCPF = null;
    }

    formatarDataNascimento(group: FormGroup) {
        const dataNascimento = group.get('dataNascimento').value;
        const dataFormatada = `${dataNascimento.substr(4, 4)}-${dataNascimento.substr(2, 2)}-${dataNascimento.substr(0, 2)}`;
        const timestamp = Date.parse(dataFormatada);

        if (isNaN(timestamp) === false) {
            return new Date(timestamp);
        } else {
            return null;
        }
    }

    formatarDataPtBr(dataNascimento) {
        return `${dataNascimento.substr(8, 2)}${dataNascimento.substr(5, 2)}${dataNascimento.substr(0, 4)}`;
    }

    showError(campo) {
        return this.form.controls[campo].errors && !this.form.controls[campo].pristine;
    }

    async updateRD() {
        // const email = this.form.get('email').value;
        // const nome = this.form.get('nome').value;
        // const celular = this.form.get('celular').value;
        const cpf = this.form.get('cpf').value;
        const dataNascimento = this.form.get('dataNascimento').value;
        // await this.rdService.carrinhoPasso2(email, nome, celular, cpf, dataNascimento);
        await this.rdService.cartPartTwo(cpf, dataNascimento);
    }

    async cadastraDadosCliente() {
        this.appComponent.showOverlay('Carregando a página de pagamento. Por favor, aguarde!');
        if (this.form.invalid) {
            this.appComponent.hideOverlay();
            return;
        }
        const proposal = this.getPropostaParaStorage();
        const cupom = this.getCupomStorage()|| {};

        let info = this.form.value;
        info.dataNascimento = this.formatarDataNascimento(this.form).toISOString().split('T')[0];
        // delete info.confirmaEmail;
        let requestInfo = this.dadosAssinatura(info, {idCupom: cupom.id, ...proposal});
        const  dadosCliente = info.assinaturaRequest.dadosCliente;
        const result = await this.assinaturaService.salvar(requestInfo);
        const { error, data} = result;
        const {idOportunidade, idCotacao, idContato, idConta, mensagem, sucesso} = data;
        const proposta = {
            nome: dadosCliente.nomeCompleto,
            cpf: dadosCliente.cpf,
            email: dadosCliente.email,
            celular: dadosCliente.celular,
            dataNascimento: dadosCliente.dataNascimento,
            cep: dadosCliente.cep,
            Codigo_IBGE_c: dadosCliente.Codigo_IBGE_c,
            endereco: dadosCliente.endereco,
            numero: dadosCliente.numero,
            complemento: dadosCliente.complemento,
            bairro: dadosCliente.bairro,
            cidade: dadosCliente.cidade,
            estado: dadosCliente.estado,
            pais : dadosCliente.pais,
            idOportunidade: (error) ? null : idOportunidade,
            idCotacao: (error) ? null : idCotacao,
            idContato: (error) ? null : idContato,
            idConta: (error) ? null : idConta,
        };
        if (error || !sucesso) {
            this.errorMessage(error, sucesso, mensagem);
            this.appComponent.hideOverlay();
        } else {
            await this.updateRD();
            this.addPropostaParaStorage(proposta);
            setTimeout(async (_) => {
                this.iframeSrc = this.paginaPagamento + '?p=' + proposta.idCotacao;
                // await this.router.navigate(['pagamentos']);
                window.open(this.iframeSrc, '_top');
                this.appComponent.hideOverlay();
            }, 5000);
        }
        return result.data;
    }
    // async cadastraDadosCliente() {
    //     this.appComponent.showOverlay('Carregando a página de pagamento. Por favor, aguarde!');
    //     if (this.form.invalid) {
    //         this.appComponent.hideOverlay();
    //         return;
    //     }
    //     let info = this.form.value;
    //     info.dataNascimento = this.formatarDataNascimento(this.form).toISOString().split('T')[0];
    //     delete info.confirmaEmail;
    //     info = this.dadosAssinatura(info);
    //     const  dadosCliente = info.assinaturaRequest.dadosCliente;
    //     const result = await this.assinaturaService.salvar(info);
    //     const { error, data} = result;
    //     const {idOportunidade, idCotacao, idContato, idConta, mensagem, sucesso} = data;
    //     const proposta = {
    //         nome: dadosCliente.nomeCompleto,
    //         cpf: dadosCliente.cpf,
    //         email: dadosCliente.email,
    //         celular: dadosCliente.celular,
    //         dataNascimento: dadosCliente.dataNascimento,
    //         cep: dadosCliente.cep,
    //         Codigo_IBGE_c: dadosCliente.Codigo_IBGE_c,
    //         endereco: dadosCliente.endereco,
    //         numero: dadosCliente.numero,
    //         complemento: dadosCliente.complemento,
    //         bairro: dadosCliente.bairro,
    //         cidade: dadosCliente.cidade,
    //         estado: dadosCliente.estado,
    //         pais : dadosCliente.pais,
    //         idOportunidade: (error) ? null : idOportunidade,
    //         idCotacao: (error) ? null : idCotacao,
    //         idContato: (error) ? null : idContato,
    //         idConta: (error) ? null : idConta,
    //     };
    //     if (error || !sucesso) {
    //         this.errorMessage(error, sucesso, mensagem);
    //         this.appComponent.hideOverlay();
    //     } else {
    //         await this.updateRD();
    //         this.addPropostaParaStorage(proposta);
    //         if (await this.isValidProposta(idCotacao)) {
    //             this.iframeSrc = this.paginaPagamento + '?p=' + proposta.idCotacao;
    //             window.open(this.iframeSrc, '_blank');
    //             this.appComponent.hideOverlay();
    //         } else {
    //             this.errorMessage(false, true, 'Algo Deu errado , tente novamente mais tarde!');
    //             this.appComponent.hideOverlay();
    //         }
    //     }
    //     return result.data;
    // }



    handleErrorMessage(message) {
        if (!message) {
            return 'Algo Deu errado , tente novamente mais tarde!';
        }
        message = message.replace('Insert failed. First exception on row 0; first error: DUPLICATES_DETECTED,', '');
        message = message.replace('[]', '');
        message = message.replace(':', '');
        return  message;
    }

    errorMessage(error, success, message) {
        let msg = (error) ? error[0].message : 'Algo Deu errado , tente novamente mais tarde!';
        msg = !success ? this.handleErrorMessage(message) : msg;
        this.toast.error(msg, '', { timeOut: 5000 });
    }
    dadosAssinatura(data: any, proposal: any): IAssinatura {
        const dadosCliente: IDadosCliente = {
            bairro: data.bairro,
            celular: proposal.mobile,
            cep: data.cep,
            cidade: data.cidade,
            complemento: data.complemento,
            cpf: data.cpf,
            Codigo_IBGE_c: data.Codigo_IBGE_c,
            dataNascimento: data.dataNascimento,
            email: proposal.email,
            endereco: data.endereco,
            estado: data.uf,
            nomeCompleto: proposal.name,
            numero: data.numero,
            pais: 'BR'
        };

        const dadosProduto: IDadosProduto = {
            fidelizacaoCliente: this.fidelizacaoCliente,
            idCupom: proposal.idCupom || "a1WN5000000AtRRMA0",
            idPriceBook: this.idPriceBook,
            idProduto: this.propostaStorage.itensProposta[0].codigoCategoriaSales,
            quantidadeDiarias: this.propostaStorage.itensProposta[0].diarias,
            reqId: "produto de teste",
        };
        return {assinaturaRequest: {dadosCliente, dadosProduto}};
    }

    async buscarCepVia($event, form: FormGroup) {
        this.appComponent.showOverlay();
        const cep = form.get('cep').value;
        if (cep && cep.length === 8) {
            const result = await this.cepService.buscaCepVia(cep);
            if (!result.error) {
                const endereco = result.data;
                let bairroInput = endereco.bairro;
                if (bairroInput.length > 35) {
                    bairroInput = bairroInput.slice(0, 35);
                }
                form.get('endereco').setValue(endereco.logradouro);
                form.get('bairro').setValue(bairroInput);
                form.get('numero').setValue(endereco.numero);
                form.get('cidade').setValue(endereco.localidade);
                form.get('uf').setValue(endereco.uf);
                form.get('Codigo_IBGE_c').setValue(endereco.ibge);
            }
        }
        this.appComponent.hideOverlay();
    }

    private async isValidProposta(idCotacao: string) {
        this.appComponent.showOverlay('Carregando a página de pagamento. Por favor, aguarde!');
        const validProposta = await this.assinaturaService.validaProposta(idCotacao);
        const { data = {}, error = null } = validProposta;
        const { SBQQ__Uncalculated__c = true} = data;
        if (error) {
            return false;
        }
        if (SBQQ__Uncalculated__c) {
            setTimeout(async (_) => {
                await this.isValidProposta(idCotacao);
            }, 2000);
        }
        this.appComponent.hideOverlay();
        return true;
    }

    handleSuccess($event: any) {}

    handleLoad($event: any) {}

    handleError($event: any) {}
}
